var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.225,
    height: 25.16,
    viewBox: "0 0 35.225 25.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M37.04,7.986a3.891,3.891,0,0,0-.805-1.493A4.193,4.193,0,0,0,33.031,5H6.193a4.193,4.193,0,0,0-3.2,1.493,3.891,3.891,0,0,0-.805,1.493A4.042,4.042,0,0,0,2,9.193V25.967A4.193,4.193,0,0,0,6.193,30.16H33.031a4.193,4.193,0,0,0,4.193-4.193V9.193a4.043,4.043,0,0,0-.185-1.208ZM6.193,6.677H33.031a2.5,2.5,0,0,1,1.828.788L20.1,17.882a.805.805,0,0,1-.973,0L4.365,7.466A2.5,2.5,0,0,1,6.193,6.677Zm29.354,19.29a2.516,2.516,0,0,1-2.516,2.516H6.193a2.516,2.516,0,0,1-2.516-2.516V9.193a.47.47,0,0,1,0-.151L18.136,19.258a2.5,2.5,0,0,0,2.919,0L35.547,9.042Z",
    transform: "translate(-2 -5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.2b33890efc7449c65618f6bec2f701c8.svg";
export { ForwardRef as ReactComponent };